export class AdminApiError extends Error {
  constructor(message, { status = 0, code = 'ADMIN_API_ERROR', fieldErrors = [], payload = null } = {}) {
    super(message)
    this.name = 'AdminApiError'
    this.status = status
    this.code = code
    this.fieldErrors = fieldErrors
    this.payload = payload
  }
}

export async function adminRequest(path, { method = 'GET', body, headers = {}, signal } = {}) {
  let response
  try {
    response = await fetch(path, {
      method,
      credentials: 'include',
      headers: { Accept: 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }), ...headers },
      body: body === undefined ? undefined : JSON.stringify(body),
      signal,
    })
  } catch (error) {
    if (error?.name === 'AbortError') throw error
    throw new AdminApiError('서버에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.', { code: 'NETWORK_ERROR' })
  }
  if (response.status === 204) return null
  const text = await response.text()
  let payload = null
  if (text) { try { payload = JSON.parse(text) } catch { payload = null } }
  if (!response.ok) {
    const apiError = payload?.error || {}
    throw new AdminApiError(apiError.message || '요청을 처리하지 못했습니다.', { status: response.status, code: apiError.code || `HTTP_${response.status}`, fieldErrors: Array.isArray(apiError.fieldErrors) ? apiError.fieldErrors : [], payload })
  }
  return payload
}

async function putObject(upload, file) {
  if (!upload?.url) throw new AdminApiError('업로드 정보를 확인할 수 없습니다.')
  const put = await fetch(upload.url, { method: upload.method || 'PUT', headers: { ...(upload.requiredHeaders || {}) }, body: file })
  if (!put.ok) throw new AdminApiError('Object Storage 이미지 업로드에 실패했습니다.', { status: put.status, code: 'OBJECT_STORAGE_UPLOAD_FAILED' })
}

export async function uploadAdminMedia(file, purpose) {
  const created = await adminRequest('/api/v1/admin/media/uploads', { method: 'POST', body: { purpose, fileName: file.name, declaredMimeType: file.type, sizeBytes: file.size } })
  const upload = created?.data?.upload, mediaId = created?.data?.mediaId
  if (!upload?.url || !mediaId) throw new AdminApiError('업로드 정보를 확인할 수 없습니다.')
  await putObject(upload, file)
  const complete = await adminRequest(`/api/v1/admin/media/${encodeURIComponent(mediaId)}/complete`, { method: 'POST' })
  return complete?.data || { mediaId }
}

export async function uploadServiceIcon(file) {
  if (!file?.type?.startsWith('image/')) throw new AdminApiError('서비스 아이콘은 이미지 파일만 등록할 수 있습니다.')
  if (file.size > 5 * 1024 * 1024) throw new AdminApiError('서비스 아이콘은 5MB 이하로 등록해주세요.')
  const created = await adminRequest('/api/v1/admin/service-icon-uploads', { method: 'POST', body: { fileName: file.name, declaredMimeType: file.type, sizeBytes: file.size } })
  const upload = created?.data?.upload, mediaId = created?.data?.mediaId
  if (!upload?.url || !mediaId) throw new AdminApiError('서비스 아이콘 업로드 정보를 확인할 수 없습니다.')
  await putObject(upload, file)
  const complete = await adminRequest(`/api/v1/admin/service-icon-uploads/${encodeURIComponent(mediaId)}/complete`, { method: 'POST' })
  return complete?.data || { mediaId }
}

export function mediaUrl(mediaId) {
  return mediaId ? `/api/v1/media/${encodeURIComponent(mediaId)}/content` : ''
}
